var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "i18n",
        {
          staticClass: "mt-4",
          attrs: {
            path: "message.accountDeactivationForm.deactivate",
            tag: "p"
          }
        },
        [
          _c(
            "b-link",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.modal1",
                  modifiers: { modal1: true }
                }
              ],
              attrs: { variant: "link", place: "deactivateLink" }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("message.accountDeactivationForm.deactivateLink")
                  ) +
                  "\n    "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal1",
            "cancel-variant": "primary",
            "ok-variant": "danger",
            title: _vm.$t("message.accountDeactivationForm.title"),
            "ok-title": _vm.$t("message.accountDeactivationForm.btn.ok"),
            "cancel-title": _vm.$t("message.accountDeactivationForm.btn.cancel")
          },
          on: { ok: _vm.deactivate }
        },
        [
          _c("p", { staticClass: "mt-4" }, [
            _vm._v(_vm._s(_vm.$t("message.accountDeactivationForm.question")))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mt-4" }, [
            _vm._v(_vm._s(_vm.$t("message.accountDeactivationForm.message")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12e61726", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12e61726","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountDeactivationForm.vue
// module id = 45aq
// module chunks = 1